import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { CosmosComponent } from '../../../types';

export const THLLogo: FC<CosmosComponent> = ({ className, isInverted }) => (
  <StyledSvg
    className={className}
    isInverted={isInverted}
    viewBox="0 0 214 99"
    role="img"
    aria-label="THL logo"
  >
    <title>THL logo</title>
    <desc>Logo of Tourism Holding Limited (THL)</desc>
    <linearGradient id="a" x1="24.943%" x2="67.111%" y1="95.28%" y2="34.968%">
      <stop offset="0" stopColor="#d6001b" />
      <stop offset=".567" stopColor="#d6001b" stopOpacity=".291" />
      <stop offset=".831" stopColor="#d6001b" stopOpacity=".089" />
      <stop offset="1" stopColor="#d6001b" stopOpacity="0" />
    </linearGradient>
    <radialGradient
      id="b"
      cx="20.453%"
      cy="51.706%"
      gradientTransform="rotate(52.333 .205 .517)"
      r="31.152%"
    >
      <stop offset="0" stopColor="#d6001b" />
      <stop offset="1" stopColor="#d6001b" stopOpacity="0" />
    </radialGradient>
    <path
      d="M92.64 52.5l-5.47 25.19a9 9 0 0 0-.36 2.4c0 3.56 2.38 5 6.38 5a19.29 19.29 0 0 0 4.2-.48l-2.76 12.75a19.23 19.23 0 0 1-7.58 1.32c-10.34 0-16.59-5.89-16.59-15.27a22.22 22.22 0 0 1 .48-4.69l5.83-26.22H66.49a33.14 33.14 0 0 0 4.12-13.56h.94c6.85 0 10.22-3.62 11.54-9.62l2.51-11.88h14.43l-4.38 20.87h11.57l-3 14.19zm89.58 27.54c0 3.61 2.39 5.09 6.36 5.05a19.39 19.39 0 0 0 4.21-.48l-2.77 12.75a19.17 19.17 0 0 1-7.57 1.32c-10.34 0-16.6-5.89-16.6-15.27a22.22 22.22 0 0 1 .48-4.69l13.12-61.28h16l-12.87 60.2a9 9 0 0 0-.36 2.4zm-42.64 17.94l6.87-32.71a18.07 18.07 0 0 0 .36-3.49c0-5.29-3.13-8.78-9-8.78-6.86 0-11.07 5.65-12.52 12.27l-7.17 32.71h-15.9l17.1-80.58h16l-5.83 27.78c3.84-4.46 9.74-6.38 15.52-6.38 11.91 0 18.53 7.94 18.53 18.65a28.65 28.65 0 0 1-.72 6.26l-2.44 11.33-4.77 22.94zm62.83-79.28l-1.19 5.53h-1.3l1.17-5.53h-2.06l.27-1.26h5.35l-.27 1.26zm7.92 5.53l1-4.73-2.88 4.73h-1l-1-4.67-1 4.67h-1.26l1.44-6.79h1.59l1 4.87 3-4.87h1.89l-1.44 6.79z"
      fillRule="nonzero"
    />
    <path
      d="M.845 26.735L8.961 30h7.82a16.654 16.654 0 0 0-.411 3.69c0 9.168 7.432 16.6 16.6 16.6s16.6-7.432 16.6-16.6-7.432-16.6-16.6-16.6a16.53 16.53 0 0 0-7.47 1.772v-4.85L18.377 4.25A32.765 32.765 0 0 1 33 .83c18.17 0 32.9 14.73 32.9 32.9S51.17 66.63 33 66.63C14.83 66.63.1 51.9.1 33.73c0-2.4.257-4.74.745-6.995z"
      fill="#ffcd01"
    />
    <path
      d="M.845 26.735L8.961 30h7.82a16.654 16.654 0 0 0-.411 3.69c0 9.168 7.432 16.6 16.6 16.6s16.6-7.432 16.6-16.6-7.432-16.6-16.6-16.6a16.53 16.53 0 0 0-7.47 1.772v-4.85L18.377 4.25A32.765 32.765 0 0 1 33 .83c18.17 0 32.9 14.73 32.9 32.9S51.17 66.63 33 66.63C14.83 66.63.1 51.9.1 33.73c0-2.4.257-4.74.745-6.995z"
      fill="url(#a)"
    />
    <path
      d="M.845 26.735L8.961 30h7.82a16.654 16.654 0 0 0-.411 3.69c0 9.168 7.432 16.6 16.6 16.6s16.6-7.432 16.6-16.6-7.432-16.6-16.6-16.6a16.53 16.53 0 0 0-7.47 1.772v-4.85L18.377 4.25A32.765 32.765 0 0 1 33 .83c18.17 0 32.9 14.73 32.9 32.9S51.17 66.63 33 66.63C14.83 66.63.1 51.9.1 33.73c0-2.4.257-4.74.745-6.995z"
      fill="url(#b)"
    />
    <circle cx="8.81" cy="28.4" fill="#9d2235" r="8.13" />
    <circle cx="22.12" cy="11.47" fill="#f9e267" r="8.13" />
  </StyledSvg>
);

const StyledSvg = styled.svg<{ isInverted?: boolean }>`
  width: 100%;
  fill: #231f20;

  ${({ isInverted }) =>
    isInverted &&
    css`
      fill: ${({ theme: { colors } }) => colors?.white};
    `}
`;
